import { render, staticRenderFns } from "./RoomChildren.vue?vue&type=template&id=77fd779d&scoped=true&"
import script from "./RoomChildren.vue?vue&type=script&lang=js&"
export * from "./RoomChildren.vue?vue&type=script&lang=js&"
import style0 from "./RoomChildren.vue?vue&type=style&index=0&id=77fd779d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77fd779d",
  null
  
)

export default component.exports